import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InfoForm } from 'src/app/helpers/models/info-form.model';
import { VippsService } from 'src/app/services/vipps.service';
import { VippsStorage } from 'src/app/storage/vipps-stored.service';

@Component({
  selector: 'app-vipps',
  templateUrl: './vipps.component.html',
})
export class VippsComponent implements OnInit {

  constructor(private vipps: VippsService, private route: ActivatedRoute, private vippsStorage: VippsStorage, private router: Router) { }

  ngOnInit(): void {
    if(this.route.queryParams){
      const snapshot = this.route.snapshot
      if(snapshot.queryParams.error){
        this.router.navigateByUrl('/')
        return
      }
      this.vipps.getUserInfo().then(res=>{
        const data: InfoForm = {
          firstname: res.given_name,
          surname: res.family_name,
          postcode:res.address.postal_code,
          address: res.address.street_address,
          email: res.email ? res.email : null,
          phone_number: res.phone_number ? res.phone_number : null,
          city: res.address.region,
          birthdate: res.birthdate,
          parent_phone: res.parent_phone,
          parent_email: res.parent_email
        }
        this.vippsStorage.isVippsLogin = true
        this.vippsStorage.setInfo(data)
        this.router.navigateByUrl('/form')
      }, err=>{
        alert('Det oppsto en feil, prøv igjen.')
        window.location.replace('/')
      })
    }
  }

}
